import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { parse, stringify } from '../../../utils/UrlUtil';
import { intlShape } from '../../../components/prop-types';

const STATUS_BUTTON = [
  {
    filter: 'ALL',
  },
  {
    filter: 'NEW',
  },
  {
    filter: 'INVITED',
  },
  {
    filter: 'STARTED',
  },
  {
    filter: 'SUBMITTED',
  },
  {
    filter: 'DECLINED',
  },
  {
    filter: 'EXPIRED',
  },
];

const messages = defineMessages({
  all: { id: 'all', defaultMessage: 'ALL' },
  new: { id: 'candidate.status.NEW', defaultMessage: 'NEW' },
  invited: { id: 'candidate.status.INVITED', defaultMessage: 'INVITED' },
  started: { id: 'candidate.status.STARTED', defaultMessage: 'IN PROGRESS' },
  declined: { id: 'candidate.status.DECLINED', defaultMessage: 'DECLINED' },
  expired: { id: 'candidate.status.EXPIRED', defaultMessage: 'EXPIRED' },
  submitted: { id: 'candidate.status.SUBMITTED', defaultMessage: 'ASSESSED' },
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  template: { id: 'attrs.assessmentTemplate', defaultMessage: 'Assessment Template' },
  language: { id: 'attrs.language', defaultMessage: 'Language' },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
});

const buildStatusFilter = (status, formatMessage) => {
  switch (status) {
    case 'ALL': {
      return {
        text: formatMessage(messages.all),
      };
    }
    case 'NEW': {
      return {
        text: formatMessage(messages.new),
      };
    }
    case 'INVITED': {
      return {
        text: formatMessage(messages.invited),
      };
    }
    case 'STARTED': {
      return {
        text: formatMessage(messages.started),
      };
    }
    case 'DECLINED': {
      return {
        text: formatMessage(messages.declined),
      };
    }
    case 'EXPIRED': {
      return {
        text: formatMessage(messages.expired),
      };
    }
    case 'SUBMITTED': {
      return {
        text: formatMessage(messages.submitted),
      };
    }
    default: {
      return {};
    }
  }
};

const statusButtonFilters = ({ onFilter, currentStatus, formatMessage }) => STATUS_BUTTON.map((status) => {
  const statusProps = buildStatusFilter(status.filter, formatMessage);
  const { text } = statusProps;

  const buttonStyle = currentStatus === status.filter ? 'p-button-info' : 'p-button-secondary';
  return (
    <Button
      key={`filter-${status.filter}`}
      label={text}
      className={buttonStyle}
      onClick={() => onFilter(status.filter)}
    />
  );
});

class TeamReportAssessmentListHeader extends Component {
  constructor(props) {
    super(props);

    // extract initial state from URL
    const { location } = this.props;
    const params = parse(location.search);

    // Make sure initial state has some nice defaults
    this.state = {
      filter: Object.assign(
        {
          status: undefined,
          query: '',
        },
        params.filter,
      ),
    };

    this.onQueryVariableChange = this.onQueryVariableChange.bind(this);
    this.onChangeQueryText = this.onChangeQueryText.bind(this);
    this.onStatusFilterChange = this.onStatusFilterChange.bind(this);
  }

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  onQueryVariableChange() {
    const { location, history } = this.props;
    const { filter } = this.state;

    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    // handle edge case for respondentType = ALL.
    if (newFilter.status === 'ALL') {
      newFilter.status = undefined;
    }

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  }

  /**
   * Update the filter Query.
   */
  onChangeQueryText(event) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        query: event.currentTarget.value,
      },
    });
  }

  onStatusFilterChange(status) {
    const { filter } = this.state;

    const newState = {
      filter: {
        ...filter,
        status,
      },
    };

    this.setState(newState, () => this.onQueryVariableChange());
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { filter } = this.state;
    const { status } = filter;
    const statusFilter = statusButtonFilters({
      onFilter: this.onStatusFilterChange,
      currentStatus: status,
      formatMessage,
    });
    return (
      <React.Fragment>
        <div className="p-col-12">
          <div className="p-inputgroup">
            <InputText value={filter.query} onChange={this.onChangeQueryText} />
            <Button
              icon="pi pi-search"
              // For search we have a search button.
              // The state is already updated. We just upate the url
              onClick={this.onQueryVariableChange}
            />
          </div>
        </div>
        <div className="p-col-12">
          <div className="status-filter">{statusFilter}</div>
        </div>
      </React.Fragment>
    );
  }
}

TeamReportAssessmentListHeader.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(TeamReportAssessmentListHeader));
